import React from 'react';
import EllipsisChat from '@tradera/tradera-ui/icons/ellipsis-chat.svg?jsx';
import * as mopinion from './mopinion-loader';
/**
 * This component displays a button that when clicked:
 * - Loads the Mopinion script
 * - Clicks an invisible button in the original Mopinion UI which is hidden by our own css.
 *
 * Why? Because we don't want to load the Mopninion script unless someone wants to give feedback.
 */
const MopinionButton = ({ memberId, mopinionDeploymentId }) => {
    const handleClick = () => {
        (function() {
            mopinion.addScriptToDom();
            mopinion.loadMopinionWidget(memberId, mopinionDeploymentId);
            mopinion.openMopinionWidget();
        })();
    };
    return (
        <div
            className="feedback-widget-trigger bp"
            onClick={() => handleClick()}>
            <EllipsisChat className="icon icon-xl icon-dark" />
        </div>
    );
};

export default MopinionButton;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/customer-feedback/mopinion-button.jsx